// Why AuthService.Login() stopped short of a logged-in user. Each value is terminal: only a
// different account (or an IT change) alters it, so the app shows the reason rather than retrying.
const SignInBlockedReasonEnum = {
  // Azure AD authenticated the account but Bravo has no active user row for it — deactivated
  // after the inactivity window, or never provisioned. See docs/USER_PROVISIONING.md.
  NoActiveUser: 'noActiveUser',

  // The token carried no claim identifying a user, so there was nothing to look up. An auth
  // configuration problem, not something the user can resolve by getting an account reactivated.
  NoIdentityClaim: 'noIdentityClaim',
};

// Markers the backend sends in place of the user array. Matched verbatim against
// Caspian2/Common/Constants/LoggedInUserConstants.cs — changing either side breaks sign-in.
export const SIGN_IN_ERROR_MARKERS = {
  MaintenanceInProgress: 'Maintenance is in progress...',
  NoIdentityClaim: 'No identity claim on the token...',
};

export default SignInBlockedReasonEnum;
